import {Component, Input} from "@angular/core";
import {Names} from "../names";

@Component({
    selector: Names.spinner.selector,
    template: require("./spinnerComponent.html"),
})
export class SpinnerComponent {

    @Input("isRunning") isRunning: boolean = true;
}


// WEBPACK FOOTER //
// ./~/@nordpoolgroup/nps-angular-2-common/src/Spinner/SpinnerComponent.ts